// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidebar */

div.sidebar {
  float: left;
}

div.sidebar.hide {
  display: none;
}

div.sidebar.active {
  display: block;
  width: 260px;
  height: 100vh;
  overflow-y: auto;
  background: #242e3e;
  color: #b5bdca;
  overflow-x: hidden;
}

div.header-logo {
  position: relative;
  align-items: center;
  display: flex;
  background: #242e3e;
  height: 70px;
  width: 100%;
  margin-right: 0;
  padding: 10px 25px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 1px 0 0 rgba(181, 189, 202, 0.2),
    7px 0 15px 0 rgba(69, 90, 100, 0.09);
}

div.header-logo .btn-default,
div.header-logo .btn-default:active,
div.header-logo .btn-default:focus {
  color: #fff;
  background-color: #242e3e !important;
  border: 0;
  box-shadow: none;
  outline: none;
}

.bootstrap-select.btn-group .dropdown-menu li,
.bootstrap-select.btn-group .dropdown-menu li:hover {
  background-color: #fff;
}
.bootstrap-select.btn-group .dropdown-menu li a span {
  color: #242e3e !important;
}
/* div.header-logo span{
  margin-left: 10px;
  font-weight: 400;
  color: #fff;
  font-size: 16px;
  flex:1
} */

div.application-option select {
  border: 0;
  background: transparent;
  font-weight: 400;
  color: #fff;
  font-size: 16px;
  flex: 1 1;
  cursor: pointer;
  border: 1px solid #b5bdca;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
}

div.application-option select option {
  color: #171d27;
}

div.header-logo select:focus {
  outline: none;
  border: 0;
  box-shadow: none;
}

div.header-logo a {
  color: #b5bdca;
}

div.header-logo span {
  margin-left: 10px;
  font-weight: 400;
  color: #fff;
  font-size: 16px;
  flex: 1 1;
}

div.logo {
  border-radius: 3px;
  /* width: 100px; */
  /* height: 30px; */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
}

/* div.switch_app{
  width: 25px;
  height: 20px;
  background: #344157;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  margin-right: 15px;
  border: 1px solid #556788
} */

/* div.switch_app select{
  width: 30px;
  background: transparent;
  border:0;
  cursor: pointer;
  -webkit-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        appearance: none;
} */

/* div.switch_app select:focus{
  outline: none;
  border: 0;
  box-shadow: none
} */

/* div.switch_app i{
  color: #4c6181;
  padding-top: 2px
}

div.switch_app:hover{
  background: #222b3a;
} */

div.drop_menus_s {
  position: absolute;
  width: 250px;
  height: 200px;
  background: white;
}

div.sidebar ul {
  padding: 0;
  margin: 0;
}

.pcoded-navbar .pcoded-inner-navbar li.pcoded-menu-caption {
  font-size: 11px;
  font-weight: 400;
  padding: 25px 15px 15px 28px;
  text-transform: capitalize;
  position: relative;
}

div.sidebar ul li {
  height: 40px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  border-left: 3px solid transparent;
}

div.sidebar ul li a {
  color: #b5bdca;
  text-decoration: none;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
}

div.sidebar ul li:hover {
  cursor: pointer;
  background: #171d27;
  color: #F79222;
}

div.sidebar ul li.active {
  border-left: 3px solid #F79222;
  background: #171d27;
}

div.sidebar ul li i {
  width: 30px;
  opacity: 0.8;
}

div.sidebar ul li.active i {
  width: 30px;
  opacity: 1;
  color: #F79222;
}

div.sidebar ul li:hover i {
  opacity: 1;
  color: #F79222;
}

div.sidebar ul li.active a {
  color: #F79222;
}

div.sidebar ul li:hover a {
  color: #F79222;
}

@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  div.sidebar.active {
    width: 60px;
  }

  div.header-logo select {
    display: none;
  }

  div.header-logo {
    height: 50px;
    width: 60px;
    margin-right: 0;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  div.logo {
    width: 25px;
    height: 25px;
  }

  div.sidebar ul li a span {
    display: none;
  }
}
td:hover {
  background-color: lightgray;
  color: #242e3e;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/App/components/Sidebar/styles.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC;wCACsC;AACxC;;AAEA;;;EAGE,WAAW;EACX,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;GAMG;;AAEH;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;;;;;;;;;;;GAWG;;AAEH;;;;;;;;;GASG;;AAEH;;;;GAIG;;AAEH;;;;;;;GAOG;;AAEH;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* sidebar */\r\n\r\ndiv.sidebar {\r\n  float: left;\r\n}\r\n\r\ndiv.sidebar.hide {\r\n  display: none;\r\n}\r\n\r\ndiv.sidebar.active {\r\n  display: block;\r\n  width: 260px;\r\n  height: 100vh;\r\n  overflow-y: auto;\r\n  background: #242e3e;\r\n  color: #b5bdca;\r\n  overflow-x: hidden;\r\n}\r\n\r\ndiv.header-logo {\r\n  position: relative;\r\n  align-items: center;\r\n  display: flex;\r\n  background: #242e3e;\r\n  height: 70px;\r\n  width: 100%;\r\n  margin-right: 0;\r\n  padding: 10px 25px;\r\n  transition: all 0.3s ease-in-out;\r\n  box-shadow: 0 1px 0 0 rgba(181, 189, 202, 0.2),\r\n    7px 0 15px 0 rgba(69, 90, 100, 0.09);\r\n}\r\n\r\ndiv.header-logo .btn-default,\r\ndiv.header-logo .btn-default:active,\r\ndiv.header-logo .btn-default:focus {\r\n  color: #fff;\r\n  background-color: #242e3e !important;\r\n  border: 0;\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.bootstrap-select.btn-group .dropdown-menu li,\r\n.bootstrap-select.btn-group .dropdown-menu li:hover {\r\n  background-color: #fff;\r\n}\r\n.bootstrap-select.btn-group .dropdown-menu li a span {\r\n  color: #242e3e !important;\r\n}\r\n/* div.header-logo span{\r\n  margin-left: 10px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  flex:1\r\n} */\r\n\r\ndiv.application-option select {\r\n  border: 0;\r\n  background: transparent;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  flex: 1;\r\n  cursor: pointer;\r\n  border: 1px solid #b5bdca;\r\n  border-radius: 0;\r\n  border-left: 0;\r\n  border-right: 0;\r\n}\r\n\r\ndiv.application-option select option {\r\n  color: #171d27;\r\n}\r\n\r\ndiv.header-logo select:focus {\r\n  outline: none;\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\ndiv.header-logo a {\r\n  color: #b5bdca;\r\n}\r\n\r\ndiv.header-logo span {\r\n  margin-left: 10px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  flex: 1;\r\n}\r\n\r\ndiv.logo {\r\n  border-radius: 3px;\r\n  /* width: 100px; */\r\n  /* height: 30px; */\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  color: #fff;\r\n}\r\n\r\n/* div.switch_app{\r\n  width: 25px;\r\n  height: 20px;\r\n  background: #344157;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  margin-right: 15px;\r\n  border: 1px solid #556788\r\n} */\r\n\r\n/* div.switch_app select{\r\n  width: 30px;\r\n  background: transparent;\r\n  border:0;\r\n  cursor: pointer;\r\n  -webkit-appearance: none;\r\n        -moz-appearance: none;\r\n        -o-appearance: none;\r\n        appearance: none;\r\n} */\r\n\r\n/* div.switch_app select:focus{\r\n  outline: none;\r\n  border: 0;\r\n  box-shadow: none\r\n} */\r\n\r\n/* div.switch_app i{\r\n  color: #4c6181;\r\n  padding-top: 2px\r\n}\r\n\r\ndiv.switch_app:hover{\r\n  background: #222b3a;\r\n} */\r\n\r\ndiv.drop_menus_s {\r\n  position: absolute;\r\n  width: 250px;\r\n  height: 200px;\r\n  background: white;\r\n}\r\n\r\ndiv.sidebar ul {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.pcoded-navbar .pcoded-inner-navbar li.pcoded-menu-caption {\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  padding: 25px 15px 15px 28px;\r\n  text-transform: capitalize;\r\n  position: relative;\r\n}\r\n\r\ndiv.sidebar ul li {\r\n  height: 40px;\r\n  padding-left: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\ndiv.sidebar ul li a {\r\n  color: #b5bdca;\r\n  text-decoration: none;\r\n  width: 100%;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\ndiv.sidebar ul li:hover {\r\n  cursor: pointer;\r\n  background: #171d27;\r\n  color: #F79222;\r\n}\r\n\r\ndiv.sidebar ul li.active {\r\n  border-left: 3px solid #F79222;\r\n  background: #171d27;\r\n}\r\n\r\ndiv.sidebar ul li i {\r\n  width: 30px;\r\n  opacity: 0.8;\r\n}\r\n\r\ndiv.sidebar ul li.active i {\r\n  width: 30px;\r\n  opacity: 1;\r\n  color: #F79222;\r\n}\r\n\r\ndiv.sidebar ul li:hover i {\r\n  opacity: 1;\r\n  color: #F79222;\r\n}\r\n\r\ndiv.sidebar ul li.active a {\r\n  color: #F79222;\r\n}\r\n\r\ndiv.sidebar ul li:hover a {\r\n  color: #F79222;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  /* For mobile phones: */\r\n  div.sidebar.active {\r\n    width: 60px;\r\n  }\r\n\r\n  div.header-logo select {\r\n    display: none;\r\n  }\r\n\r\n  div.header-logo {\r\n    height: 50px;\r\n    width: 60px;\r\n    margin-right: 0;\r\n    padding: 0;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  div.logo {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n\r\n  div.sidebar ul li a span {\r\n    display: none;\r\n  }\r\n}\r\ntd:hover {\r\n  background-color: lightgray;\r\n  color: #242e3e;\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
